import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  CircularProgress,
  Text,
} from "@chakra-ui/react";
import { P, match } from "ts-pattern";
import { useAnalytes } from "../../services/projectService";
import { ProjectID } from "../../types/project";

export function NonDetectedAnalytes({
  startDate,
  endDate,
  sites,
  project,
}: {
  startDate: Date;
  endDate: Date;
  sites: string[];
  project: ProjectID;
}) {
  const query = useAnalytes(project, sites, startDate, endDate, false);

  return match(query)
    .with({ isLoading: true }, () => <CircularProgress isIndeterminate color="brand.400" />)
    .with({ isError: true }, () => <Text color="red">Error loading analytes</Text>)
    .with({ data: P.nullish }, () => <></>)
    .otherwise(({ data }) => (
      <Accordion allowMultiple>
        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box as="span" flex="1" textAlign="left">
                Non-Detected Analytes
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>{data.join(", ")}</AccordionPanel>
        </AccordionItem>
      </Accordion>
    ));
}
